import React from 'react';
import VisibilityManager from '../features/people/VisibilityManager';
import AccountMappingsManager from '../features/people/AccountMappingsManager';
import PageHeader from '../components/PageHeader';

const VisibilityManagerPage: React.FC<{ schoolYear: string, onVisibilityChange: () => void }> = ({ schoolYear, onVisibilityChange }) => {
    return (
        <div className="page">
            <PageHeader title="Zarządzaj osobami" subtitle={`Rok szkolny ${schoolYear} — zmień nazwę lub ukryj dziecko w podsumowaniu`} />
            <VisibilityManager schoolYear={schoolYear} onVisibilityChange={onVisibilityChange} />
            <AccountMappingsManager />
        </div>
    );
};

export default VisibilityManagerPage;
